import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import PrettoSlider from './SlideMui';
import './TopUp.css';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';


function TopUp({ onClose }) {
  const [tokenNumber, setTokenNumber] = useState(0);

  useEffect(() => {
    setTokenNumber(prevCount => prevCount + 1);
  }, []);

  const handleSliderChange = (event, newValue) => {
    setTokenNumber(newValue);
  };

  return (
    <div className='Topup-container'>
       <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: '#fff' }}
      >
        <CloseIcon />
      </IconButton>
      <div className="header">
        <h1>Top-up your account</h1>
        <p>More tokens, less stress 🔥</p>
      </div>

      <div className='body'>
        <h1>{tokenNumber}</h1>
        <PrettoSlider 
          value={tokenNumber}
          valueLabelDisplay="auto" 
          aria-label="pretto slider" 
          onChangeCommitted={handleSliderChange}
          className='topupbar'
        />
      </div>

      <div className="footer">
      <Button variant="contained" endIcon={<ShoppingCartIcon />} sx={{width: '100%', marginBottom: '10px', backgroundColor: '#3e65ffd7'}}>
        Top-up Now
      </Button>

      </div>

    </div>
  )
}

export default TopUp
